/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type AuditActionResponseSeverity = typeof AuditActionResponseSeverity[keyof typeof AuditActionResponseSeverity];


export const AuditActionResponseSeverity = {
  info: 'info',
  warning: 'warning',
  critical: 'critical',
} as const;
